require('./../scss/main.scss');

const Kernel = require('../../common/js/utils/Kernel');
window.Kernel = new Kernel();

window.Kernel.registerComponent('FilterArticle', require('../../frontend/js/components/msf/FilterArticle').default);
window.Kernel.registerComponent('SavMail', require('./components/clients/SavMail').default);

document.addEventListener("DOMContentLoaded", function() {
    window.Kernel.mountComponents($('html'));
});
